var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import Button from "@mui/material/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import SaveIcon from "@material-ui/icons/Save";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from "@mui/material/Select";
import moment from "moment";
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { MuiThemeProvider} from '@material-ui/core/styles';
import EditRoleDialog from '../EditDialogue/EditRoleDialog';
import RoleDialog from '../CreateDialogue/RoleDialog';
import { muiThemeDesign } from '../../mui-theme-design';
import {logger, customBodyForExcelReport,handleExport,permissions,muiLoaderOptions} from '../../utils';
import { Stack,CircularProgress } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
const ExcelJS = require('exceljs');


export default function RoleTable() {
    const [saveAlert, setSaveAlert] = React.useState(false);
    const [refresh, setRefresh] = React.useState(true);
    const [isLoading, setIsLoading] = React.useState(true);
    const [Roles, setRoles] = React.useState([]);

    const handleDialogCallback = (childData) => {
        fetch("api/Role", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "role": [{
                    "UserID": childData.UserID,
                    "LabID": childData.LabID,
                    "PositionID": childData.PositionID,
                    "StartDate": childData.StartDate,
                    "EndDate": childData.EndDate,
                    "IsActive": childData.IsActive
                }]
            })
        })
        logger(childData);
        setRefresh(true)
    };

    const handleSaveAlertClose = () => {
        setSaveAlert(false)
    };

    const handleEditCallback = (childData) => {
        fetch("api/Role", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "role": {
                    "ID": childData.ID,
                    "UserID": childData.UserID,
                    "LabID": childData.LabID,
                    "PositionID": childData.PositionID,
                    "StartDate": childData.StartDate,
                    "EndDate": childData.EndDate,
                    "IsActive": childData.IsActive
                }
            })
        }).then(response => {
            if (response.status == 409) {
                setSaveAlert(true)
            }
        })

        logger(childData);
        setRefresh(true)
    };

	React.useEffect(() => {

		if (refresh) {
			fetch('api/role', {
				method: 'Get',
			})
				.then(res => res.json())
				.then(json => {
					setRoles(json);
					setIsLoading(false);
				})

			setRefresh(false)
		}
	})
    
    const columns = [];
    if(permissions.CreateUserRoles==1){
	    const adminActions = {
            name: "Admin Actions",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            <EditRoleDialog handleEditCallback={handleEditCallback} data={Roles[dataIndex]} />
                        </div>
                    );
                }

            }
        };
        columns.push(adminActions);
    }
        
    const columns1 = [
		{
			//name: "FirstName+LastName",
			name: "Name",
            label: "Name",
            options: {
                filter: true,
                sort: true,
                /*customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        Roles[dataIndex].FirstName + " " + Roles[dataIndex].LastName
                    );
                }*/
            }
        },
        {
            name: "Lab",
            label: "Lab",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Position",
            label: "Position",
            options: {
                filter: true,
                sort: true,                
				customBodyRenderLite: (dataIndex, rowIndex) => {
					var positionName = Roles[dataIndex].Position;
					var defaultRoleStatus = Roles[dataIndex].DefaultRoleStatus;
					var defaultRoleName = Roles[dataIndex].DefaultRoleName;
					if (defaultRoleStatus === 0) {
						return (
							<Tooltip title={`Position:${positionName} is Inactive`} placement="top-end">
								<div style={{ color: "red" }}>
									{positionName}
								</div>
							</Tooltip>
						);
					} else if (moment(Roles[dataIndex].EndDate).isSameOrBefore(moment(new Date()))) {
						return (
							<Tooltip title={`Default Role :${defaultRoleName} has expired`} placement="top-end">
								<div style={{ color: "red" }}>
									{positionName}
								</div>
							</Tooltip>
						);
					} else if (!Roles[dataIndex].IsActive) {
						return (
							<Tooltip title={`Role:${defaultRoleName} is InActive`} placement="top-end">
								<div style={{ color: "red" }}>
									{positionName}
								</div>
							</Tooltip>
						);
					} else {
						return (
							<Tooltip>
								<div>
									{positionName}
								</div>
							</Tooltip>
						);
					}
				}
            }
        },
        {
            name: "StartDate",
            label: "Start Date",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(Roles[dataIndex].StartDate).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "EndDate",
            label: "End Date",
            options: {
                filter: true,
                sort: true,
				customBodyRenderLite: (dataIndex, rowIndex) => {
					var defaultRoleName = Roles[dataIndex].DefaultRoleName;
					if (moment(Roles[dataIndex].EndDate).isSameOrBefore(moment(new Date()))) {
						return (
							<Tooltip title={`DefaultRole:${defaultRoleName} has expired`} placement="top-end">
								<div style={{ color: "red" }}>
									{moment.utc(Roles[dataIndex].EndDate).format("MM/DD/YYYY")}
								</div>
							</Tooltip>
						);
					} else {
						return (
							<Tooltip>
								<div>
									{moment.utc(Roles[dataIndex].EndDate).format("MM/DD/YYYY")}
								</div>
							</Tooltip>
						);
					}
				}
            }
        },
		{
            name: "IsActive",
            options: {
                filter: true,
                sort: true,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                        	{(Roles[dataIndex].IsActive) ? <CheckIcon /> : <DoNotDisturbIcon />}
                        </div>
                    );
                }
            }
		}	
	];
    columns.push(...columns1);

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('RolerowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('RolerowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();
	
	const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',
        textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		  onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				for (var i = 0; i < Roles.length; i++) {
					var eachRow = data[i].data;
					eachRow[4] =  moment.utc(eachRow[4]).format("MM/DD/YYYY")
					eachRow[5] =  moment.utc(eachRow[5]).format("MM/DD/YYYY")
				}
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({rows:rows, headers:headers, filename:'UserRoles.xlsx', columnIndexToRemove:0});
			return false;
		}
    };
    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    if(permissions.CreateUserRoles==1 && !isLoading ){
		const addUserDialog = ()=> (<RoleDialog handleDialogCallback={handleDialogCallback} />);
	    options.customToolbar = addUserDialog;	
    }
    
    return (       
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
		      <Box style={{ minHeight: '100vh' }}>
		        <MUIDataTable
		          className="RolesTable"
		          title={
		            <Typography variant="h6" style={{ color: "white" }}>
		              Beyondsoft User Roles
		            </Typography>
		          }
		          data={isLoading ? [] : Roles}
		          columns={columns}
		          options={muiLoaderOptions(options, isLoading)}
		        />
		      </Box>
		    </MuiThemeProvider>
		  );
            <Dialog
                open={saveAlert}
                onClose={handleSaveAlertClose}
                aria-labelledby="alert-title"
                aria-describedby="alert-description"
            >
                <DialogTitle id="alert-title">
                    {"SAVE FAILED"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-description">
                        Billed time conflict
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setSaveAlert(false) }}>close</Button>
                </DialogActions>
            </Dialog>
        </Box>
        
    );
}